angular.module('dnecom').controller('CampaignBuilderController', ["$scope", "$http", "notifications", "Upload", "$q", "$sce", "$timeout", function($scope, $http, notifications, Upload, $q, $sce, $timeout) {
    $scope.store = TemplateData.value('store');
    $scope.shortCodes = TemplateData.value('shortCodes');
    $scope.textShortCodes = TemplateData.value('textShortCodes');

    $scope.promoCodes = TemplateData.value('promoCodes');

    $scope.imgix = location.protocol + '//' + $('meta[name="imgix-domain"]').attr('content');

    $scope.template = {};

    $scope.isShortCodePickerOpen = false;

    $scope.selectedTemplateIndex = 0;
    $scope.activeElement = '';
    $scope.activeTab = 'messages';

    $scope.selectedMessage = -1;

    $scope.messages = [];
    $scope.templateApplied = false;
    $scope.templates = [];
    $scope.canvas = [];

    $scope.layoutItems = [];

    $scope.summernoteOptions = {
        height: 200,
        toolbar: [
            ['color', ['color']],
            ['fontname', ['fontname']],
            ['fontsize', ['fontsize']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['alignment', ['paragraph']],
            ['insert', ['link']],
            ['shortcodeButton', ['shortcodeButton']]
        ],
        buttons: {
            shortcodeButton: function(context) {
                var ui = $.summernote.ui;

                var button = ui.buttonGroup([
                    ui.button({
                        className: 'dropdown-toggle',
                        contents: '[/]',
                        data: {
                            toggle: 'dropdown'
                        }
                        // click: $scope.openShortCodePicker
                    }),
                    ui.dropdown({
                        className: 'drop-default summernote-list',
                        contents: $scope.getShortcodesHtml(),
                        callback: function($dropdown) {
                            $dropdown.find('.shortcode-button').click(function(event) {
                                context.invoke('editor.insertText', $(event.delegateTarget).data('content'));
                            });
                        }
                    })
                ]);

                return button.render();
            }
        }
    };

    var promocodeStyles = {
        1 : {
            'background': '#fefefe',
            'border': '#bfbdbf'
        },
        2 : {
            'background': '#F4F6F4',
            'border': '#f6565d'
        },
        3 : {
            'background': '#8375FF',
            'border': 'white'
        },
        4 : {
            'background': '#3CCA7C',
            'border': '#3CCA7C'
        },
        5 : {
            'background': '',
            'border': ''
        }
    };

    var onPromocodeStyleChange = function(newValue, oldValue) {
        if ($scope.activeElement.type != 'promo_code' || !newValue || !promocodeStyles[newValue]) {
            return;
        }

        if (
            !$scope.activeElement.fields.promocode_background_color
            || (oldValue && $scope.activeElement.fields.promocode_background_color == promocodeStyles[oldValue].background)
        ) {
            $scope.activeElement.fields.promocode_background_color = promocodeStyles[newValue].background;
        }

        if (
            !$scope.activeElement.fields.promocode_border_color
            || (oldValue && $scope.activeElement.fields.promocode_border_color == promocodeStyles[oldValue].border)
        ) {
            $scope.activeElement.fields.promocode_border_color = promocodeStyles[newValue].border;
        }
    };

    $scope.$watch('activeElement.fields.style', onPromocodeStyleChange);

    $scope.getShortcodesHtml = function() {
        var html = '<div class="short-code-picker short-code-picker-editor"><ul class="list-unstyled ng-scope">';

        for (var i = 0; i < $scope.textShortCodes.length; i++) {
            html += '<li class="shortcode-button" data-content="{{ ' + $scope.textShortCodes[i].name + ' }}"><a tabindex>';
                html += '<h5 class="code">[' + $scope.textShortCodes[i].name + ']</h5>';
                html += '<span class="description">' + $scope.textShortCodes[i].description + '</span>';
            html += '</a></li>';
        }

        html += '</ul></div>';

        return html;
    };

    $scope.clearBuilder = function() {
        $scope.template = {};
        $scope.canvas = [];
        $scope.selectedTemplateIndex = 0;
        $scope.activeElement = '';
        $scope.templateApplied = false;
        $scope.activeTab = 'messages';
    };

    $scope.cleanCanvas = function() {
        $scope.clearBuilder();
        $scope.initBuilder();
    };

    var initSortable = function() {
        $('#campaign-dynamic-canvas').sortable({
            placeholder: 'campaign-placeholder',
            stop: function(event, ui) {
                output = [];

                $('#campaign-dynamic-canvas').find('.campaign-element').each(function(){
                    var index = $(this).attr('index');
                    output.push($scope.canvas[index]);
                });

                $scope.canvas = output;
                $scope.$apply();

                // there's a bug that sometimes causes sortable to start ordering items in a wrong way;
                // to avoid it, we reset the whole thing after each rearranging
                $timeout(function() {
                    $('#campaign-dynamic-canvas').sortable('destroy');
                    initSortable();
                });
            }
        }).disableSelection();
    };

    $scope.initBuilder = function() {
        $('.campaign-buttons li').draggable({
            scroll: true,
            helper: 'clone'
        });

        initSortable();

        $('#campaign-canvas').droppable({
            hoverClass: 'ui-state-highlight',
            accept: ':not(.ui-sortable-helper)',
            drop: function(ev, ui) {
                builderId = $(ui.draggable).index();
                var component = JSON.parse(JSON.stringify($scope.layoutItems[builderId]));
                $scope.canvas.push(component);
                $scope.$apply();
            }
        });

        $scope.getTemplates();
    };

    $scope.chooseTemplate = function(index) {
        $scope.selectedTemplateIndex = index;
    };

    $scope.applyTemplate = function() {
        $scope.template = $scope.templates[$scope.selectedTemplateIndex];
        $scope.template.id = null;
        $scope.renderCanvas($scope.template.components);
        $scope.templateApplied = true;
        $scope.initBuilder();
    };

    $scope.getComponents = function() {
        $http.get(
            Routing.generate('campaign_get_email_components', {
                store: $scope.store.id
            })
        ).then(function(response) {
            response = response.data;

            $scope.layoutItems = response.components;
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.getTemplates = function() {
        $http.post(
            Routing.generate('campaign_custom_templates', {
                store: $scope.store.id
            })
        ).then(function(response) {
            response = response.data;

            $scope.messages = response.customTemplates;
            $scope.templates = response.defaultTemplates;
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.loadTemplate = function(item) {
        $http
            .post(Routing.generate('campaign_get_custom_template', {
                store: $scope.store.id,
                templateId: item.id
            }))
            .then(function(response) {
                $scope.template = response.data.template;

                $scope.renderCanvas($scope.template.components);

                $scope.templateApplied = true;
                $scope.initBuilder();
            }, function() {
                notifications.danger('Request error.');
            });
    };

    function removeDuplicatedSpans(components) {
        for (var index in components) {
            if (!components[index].content) {
                continue;
            }
            var el = angular.element('<div>').html(components[index].content);

            el.find("span[style]").each(function(index) {
                var $el = angular.element(this);
                var hasBrokenTags = this.outerHTML.indexOf('{{') === -1 && this.outerHTML.indexOf('{') !== -1
                    || this.outerHTML.indexOf('}}') === -1 && this.outerHTML.indexOf('}') !== -1;

                if ($el.find('span').length || !hasBrokenTags) {
                    return;
                }

                this.outerHTML = this.innerHTML;
            });

            var content = el.html();
            if (!content) {
                continue;
            }
            console.log('before: ',components[index].content);
            console.log('after: ',content);

            components[index].content = content;
        }
    }

    $scope.saveTemplate = function(rename) {
        removeDuplicatedSpans($scope.canvas);
        $http
            .put(Routing.generate('campaign_save_custom_template', {
                store: $scope.store.id
            }), {
                id: $scope.template.id,
                name: $scope.template.name,
                subject: $scope.template.subject,
                components: (rename ? null : $scope.canvas)
            })
            .then(function(response) {
                response = response.data;

                if (!response.success) {
                    notifications.danger(response.message || 'Failed to save template.');
                    return;
                }

                $scope.template = response.template;
                $scope.getTemplates();

                notifications.success('Template saved!');
            }, function() {
                notifications.danger('Request error.');
            });
    };

    $scope.sendTestEmail = function() {
        if ($scope.isEmailTesting) {
            return;
        }

        $scope.isEmailTesting = true;

        $http
            .post(Routing.generate('campaign_send_test_email', {
                store: $scope.store.id
            }), {
                id: $scope.template.id,
                subject: $scope.template.subject,
                components: $scope.canvas
            })
            .then(function(response) {
                if (!response.data.success) {
                    notifications.danger('Failed to send email:' + (response.data.message || 'Unknown error.'));
                    return;
                }

                notifications.success('Test email has been sent to ' + $scope.store.email);
            }, notifications.fromResponse)
            .finally(function() {
                $scope.isEmailTesting = false;
            });
    };

    $scope.renameModalOpen = function(index) {
        $scope.selectedMessage = index;
        $('#campaign-template-rename').modal('show');
    };

    $scope.renameTemplate = function() {
        $scope.template.id = $scope.messages[$scope.selectedMessage].id;
        $scope.template.name = $scope.messages[$scope.selectedMessage].name;
        $scope.saveTemplate(true);

        $('#campaign-template-rename').modal('hide');
    };

    $scope.duplicateTemplate = function(item) {
        $http
            .post(Routing.generate('campaign_clone_custom_template', {
                store: $scope.store.id,
                templateId: item.id
            }))
            .then(function() {
                $scope.getTemplates();
            }, function() {
                notifications.danger('Request error.');
            });
    };

    $scope.deleteTemplate = function(item) {
        if (item.id === $scope.template.id) {
            $scope.clearBuilder();
            $scope.initBuilder();
        }

        $http
            .post(Routing.generate('campaign_delete_custom_template', {
                store: $scope.store.id,
                templateId: item.id
            }))
            .then(function(response) {
                if (response.data.success) {
                    notifications.success('Template deleted successfully.');
                    $scope.getTemplates();
                } else {
                    notifications.danger(response.data.message || 'Invalid server response.');
                }
            }, function() {
                notifications.danger('Request error.');
            });
    };


    $scope.setActiveElement = function(item) {
        item.selector = '#' + item.type;
        $scope.activeElement = item;
        $scope.activeTab = 'styles';

        if (item.type == 'promo_code') {
            onPromocodeStyleChange(item.fields.style);
        }
    };

    $scope.applyActiveElement = function() {
        if ($scope.activeElement.type == 'image' && !$scope.activeElement.fields.width) {
            getImageSize(
                $scope.activeElement.fields.image_url,
                function(width, height) {
                    $scope.activeElement.fields.width = width;
                    $scope.activeElement.fields.height = height;
                    $scope.renderComponent($scope.activeElement);
                }
            );
        } else {
            $scope.renderComponent($scope.activeElement);
        }
    };

    $scope.duplicateElement = function(element) {
        var element = JSON.parse(JSON.stringify(element));
        $scope.canvas.push(element);
    };

    $scope.removeElement = function(index) {
        $scope.canvas.splice(index, 1);
        $scope.activeElement = '';
        $scope.changeTab('layout');
    };

    $scope.scroll = function() {
        $('.campaign-builder-header').removeClass('campaign-header-fixed');

        if ($(window).scrollTop() > 120) {
            $('.campaign-builder-header').addClass('campaign-header-fixed');
        }
    };

    $scope.changeTab = function(tabName) {
        if ($scope.templateApplied) {
            $scope.activeTab = tabName;
        }
    };

    $scope.openShortCodePicker = function() {
        $http
            .get(Routing.generate('campaign_get_short_codes', {
                placement: 'text'
            }), { cache: true })
            .then(function (response) {
                if (response.data.success) {
                    $scope.shortCodes = response.data.shortCodes;
                } else {
                    notifications.danger(response.data.message || 'Invalid server response.');
                }

                $scope.isShortCodePickerOpen = true;
            }, function () {
                notifications.danger('Request error');
            })
        ;
    };

    $scope.appendShortCode = function(shortCode) {
        $scope.isShortCodePickerOpen = false;
        $scope.template.subject = $scope.template.subject + shortCode;
    };

    $scope.closeShortCodePicker = function() {
        $scope.isShortCodePickerOpen = false;
    };

    $scope.renderCanvas = function(components) {
        $scope.canvas = [];

        $http
            .put(Routing.generate('campaign_render_template_components', {
                store: $scope.store.id
            }), components)
            .then(function(response) {
                response = response.data;

                var componentsHtml = response.html;

                for (var index in components) {
                    components[index].html = componentsHtml[index];
                    $scope.canvas.push(components[index]);
                }
            }, function() {
                notifications.danger('Request error.');
            });
    };

    $scope.renderComponent = function(component) {
        $http
        .put(Routing.generate('campaign_render_component', {
            store: $scope.store.id
        }), {
            type : component.type,
            content : component.content,
            fields : component.fields
        })
        .then(function(response) {
            response = response.data;

            component.html = response.html;
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.isEditorAllowed = function(component) {
        return ['paragraph', 'title', 'image_text', 'social'].indexOf(component.type) != -1;
    };

    $scope.uploadImage = function(file) {
        var deferred = $q.defer();

        if (file) {
            return Upload
                .upload({
                    url: Routing.generate('upload_file', {store: $scope.store.id}),
                    data: {
                        file: file
                    }
                })
                .then(function(response) {
                    if (response.data.success) {
                        var imageUrl = $scope.imgix + response.data.media.imgixName;

                        if ($scope.activeElement.fields.width) {
                            $scope.activeElement.fields.image_url = imageUrl;
                        } else {
                            getImageSize(imageUrl, function(width, height) {
                                $scope.activeElement.fields.image_url = imageUrl;
                                $scope.activeElement.fields.width = width;
                                $scope.activeElement.fields.height = height;
                            });
                        }
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function() {
                    notifications.danger('There was a problem with image uploading.');
                });
        } else {
            deferred.reject();
        }

        return deferred.promise;
    };

    var getImageSize = function(url, callback) {
        var img = new Image();

        img.onload = function () {
            $scope.$apply(function() {
                callback(img.width, img.height);
            });
        };

        img.onerror = function() {
            notifications.danger('Invalid image.');
        };

        img.src = url;
    };

    $(document).ready(function() {
        $scope.clearBuilder();
        $scope.initBuilder();
        $scope.getComponents();
    });

    $(window).scroll(function() {
        $scope.scroll();
    });
}]);
